export const FETCH_DSCONFIG = 'FETCH_DSCONFIG';
export const SET_DSCONFIG = 'SET_DSCONFIG';
export const ADD_BRAND = 'ADD_BRAND';
export const REMOVE_BRAND = 'REMOVE_BRAND';
export const ADD_OEM_COLOR = 'ADD_OEM_COLOR';